
export type CancelEnrollmentByCourseIdBody = {
  /** 취소 사유 */
  reason?: string;
};
